document.addEventListener('DOMContentLoaded', function () {
    const filterOptions = document.querySelectorAll('.filter-option');
    const items = document.querySelectorAll('#product-grid li');

    // Count items by type
    const typeCounts = {};
    items.forEach(item => {
      const type = item.getAttribute('data-type');
      if (!typeCounts[type]) {
        typeCounts[type] = 0;
      }
      typeCounts[type]++;
    });

    // Update filter options
    filterOptions.forEach(option => {
      const type = option.getAttribute('data-type');
      const count = typeCounts[type] || 0;

      // Update the label to show the count
      option.textContent = `${capitalize(type)} (${count})`;

      if (count === 0) {
        option.classList.add('disabled');
        option.setAttribute('aria-disabled', 'true');
        option.style.pointerEvents = 'none';
        option.style.opacity = '0.5';
      } else {
        // Click to show only selected type
        option.addEventListener('click', () => {
          filterOptions.forEach(o => o.classList.remove('active'));
          option.classList.add('active');

          items.forEach(item => {
            item.style.display = item.getAttribute('data-type') === type ? '' : 'none';
          });
        });
      }
    });

    // Helper: Capitalize first letter
    function capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  });